import { render, staticRenderFns } from "./MyCollectionCategory.vue?vue&type=template&id=35234cbc&"
import script from "./MyCollectionCategory.vue?vue&type=script&lang=js&"
export * from "./MyCollectionCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports